import React from 'react';
import { motion } from 'framer-motion';
import { Map, Lightbulb, Download, Calendar } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const SocialProof = () => {
  const { language } = useLanguage();

  const texts = {
    it: {
      title: "Tutto ciò che ti serve",
      subtitle: "Ogni guida include strumenti essenziali per un viaggio perfetto",
      features: [
        {
          icon: Calendar,
          title: "Itinerari Giorno per Giorno",
          description: "Piani dettagliati ottimizzati per non perdere nulla"
        },
        {
          icon: Map,
          title: "Mappe Interattive",
          description: "Tutti i luoghi salvati, pronti per il tuo GPS"
        },
        {
          icon: Lightbulb,
          title: "Consigli da Insider",
          description: "Segreti locali che non trovi nelle guide turistiche"
        },
        {
          icon: Download,
          title: "PDF Scaricabile",
          description: "Accesso offline, sempre disponibile"
        }
      ]
    },
    en: {
      title: "Everything you need",
      subtitle: "Each guide includes essential tools for a perfect trip",
      features: [
        {
          icon: Calendar,
          title: "Day-by-Day Itineraries",
          description: "Detailed plans optimized so you don't miss anything"
        },
        {
          icon: Map,
          title: "Interactive Maps",
          description: "All locations saved, ready for your GPS"
        },
        {
          icon: Lightbulb,
          title: "Insider Tips",
          description: "Local secrets you won't find in tourist guides"
        },
        {
          icon: Download,
          title: "Downloadable PDF",
          description: "Offline access, always available"
        }
      ]
    }
  };

  const t = texts[language];

  return (
    <section className="py-24 bg-[#0A0A0A]" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-[#888] max-w-xl mx-auto">
            {t.subtitle}
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-[#1a1a1a] border border-[#333] flex items-center justify-center">
                <feature.icon className="w-7 h-7 text-[#C9B896]" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-[#888] text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
